import { render, staticRenderFns } from "./TabBarComponent.vue?vue&type=template&id=1413e6a3&scoped=true&"
import script from "./TabBarComponent.vue?vue&type=script&lang=js&"
export * from "./TabBarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413e6a3",
  null
  
)

export default component.exports